<template>
  <b-modal title="Informações da Atividade" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group
            label="Cliente:"
            label-for="cliente"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-select v-model="editing.cliente">
              <b-form-select-option
                v-for="cliente of clienteStore.clientes"
                v-bind:key="cliente.id"
                :value="cliente"
                >{{ cliente.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group
            label="Descrição:"
            label-for="descricao"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-textarea v-model="editing.descricao" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Grupo:" label-for="grupo" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="grupo" v-model="editing.grupo" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="Data:" label-align-sm="right" label-for="data">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Local:" label-for="local" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="local" v-model="editing.local" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Referência:" label-for="referencia" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="referencia" v-model="editing.referencia" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group
            label="Responsável:"
            label-for="responsavel"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="responsavel" v-model="editing.responsavel" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useAtividadeStore } from "@/stores/AtividadeStore";
import { useClienteStore } from "@/stores/ClienteStore";
import { storeToRefs } from "pinia";
import Atividade from "@/models/Avulso";
import Notificacao from "@/models/Notificacao";

export default {
  name: "ModalDeEdicaoDeAtividade",

  data() {
    return {
      show: false,
      editing: new Atividade(0, "Nova Atividade", "", new Date(), "", ""),
    };
  },

  watch: {
    selecionado: function (cliente) {
      this.editing.cliente = cliente;
    },
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.atividadeStore.ALTERAR_ATIVIDADE(this.editing).then(() => {
          this.store.NOTIFICAR(
            new Notificacao(
              "Atividade de equipe salva no SGCQ com sucesso!",
              "Excelente!",
              "success"
            )
          );
        });
      } else {
        this.atividadeStore
          .CADASTRAR_ATIVIDADE(this.editing)
          .then(() =>
            this.store.NOTIFICAR(
              new Notificacao(
                "Atividade de equipe salva no SGCQ com sucesso!",
                "Excelente!",
                "success"
              )
            )
          );
      }
      this.show = !this.show;
    },

    call(atividade) {
      this.show = !this.show;
      this.editing = atividade;
    },
  },

  setup() {
    const store = useSgcqStore();
    const atividadeStore = useAtividadeStore();
    const clienteStore = useClienteStore();
    const { getFilterClientes } = storeToRefs(clienteStore);

    return {
      store,
      atividadeStore,
      clienteStore,
      getFilterClientes,
    };
  },
};
</script>

<style lang="scss" scoped></style>
